import React from 'react';
const MasterCard = ({ width = 30, height = 22 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-696 -297)" fillRule="nonzero">
        <g id="credit_card" transform="translate(128 261)">
          <g id="cards" transform="translate(568 36)">
            <g id="credit-cards_mastercard">
              <g id="Layer_1">
                <path
                  d="M1.25,0 L28.75,0 C29.4375,0 30,0.529411765 30,1.17647059 L30,18.8235294 C30,19.4705882 29.4375,20 28.75,20 L1.25,20 C0.5625,20 0,19.4705882 0,18.8235294 L0,1.17647059 C0,0.529411765 0.5625,0 1.25,0 Z"
                  id="Shape"
                  fill="#4361C3"
                />
                <path
                  d="M18.59375,6.25 C21.09375,6.25 23.125,8.28125 23.125,10.78125 C23.125,13.28125 21.09375,15.3125 18.59375,15.3125 C16.09375,15.3125 14.0625,13.28125 14.0625,10.78125 C14.0625,8.28125 16.09375,6.25 18.59375,6.25 Z"
                  id="Shape"
                  fill="#FFAF38"
                />
                <rect
                  id="Rectangle-path"
                  fill="#FFAF38"
                  x="14.688"
                  y="8.438"
                  width="3.125"
                  height="1"
                />
                <path
                  d="M11.40625,15.3125 C8.90625,15.3125 6.875,13.28125 6.875,10.78125 C6.875,8.28125 8.90625,6.25 11.40625,6.25 C13.90625,6.25 15.9375,8.28125 15.9375,10.78125 C15.9375,13.28125 13.90625,15.3125 11.40625,15.3125 Z"
                  id="Shape"
                  fill="#EB3636"
                />
                <path
                  d="M14.6875,12.8125 L14.6875,12.1875 L18.75,12.1875 L18.75,12.8125 L14.6875,12.8125 Z M14.6875,8.4375 L18.75,8.4375 L18.75,9.0625 L14.6875,9.0625 L14.6875,8.4375 Z M18.4375,10.3125 L14.375,10.3125 L14.375,9.6875 L18.4375,9.6875 L18.4375,10.3125 Z M18.4375,11.5625 L14.375,11.5625 L14.375,10.9375 L18.4375,10.9375 L18.4375,11.5625 Z"
                  id="Shape"
                  fill="#FFAF38"
                />
                <path
                  d="M1.25,21.25 L1.8125,21.25 L30,1.8125 L30,1.25 C30,0.5625 29.4375,0 28.75,0 L1.25,0 C0.5625,0 0,0.5625 0,1.25 L0,20 C0,20.6875 0.5625,21.25 1.25,21.25 Z"
                  id="Shape"
                  fill="#FFF"
                  opacity="0.05"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default MasterCard;



// WEBPACK FOOTER //
// ../shop_main/images/masterCardIcon.js